import getRuleError from "../utils/getRuleError";
import getRuleValue from "../utils/getRuleValue";
import {translate} from "../../../../i18n";
import getRequiredError from "../utils/getRequiredError";

let $value, $rules, $options, $allValues;

export default function (value, rules, options, allValues) {
    $value = value;
    $rules = rules;
    $options = options;
    $allValues = allValues;

    return checkRequired() || checkMinSelectable() || checkMaxSelectable();
}

function checkRequired() {
    if ($value.length > 0) {
        return null;
    }

    return getRequiredError($rules, $options, $allValues);
}

function checkMinSelectable() {
    const {minSelectable} = $rules;

    if (minSelectable === undefined) {
        return null;
    }

    const ruleValue = getRuleValue(minSelectable, $allValues);

    if ($value.length >= ruleValue) {
        return null;
    }

    return getRuleError(minSelectable, $allValues, translate('min_selections{number}', {number: ruleValue}));
}

function checkMaxSelectable() {
    const {maxSelectable} = $rules;

    if (maxSelectable === undefined) {
        return null;
    }

    const ruleValue = getRuleValue(maxSelectable, $allValues);

    if ($value.length <= ruleValue) {
        return null;
    }

    return getRuleError(maxSelectable, $allValues, translate('max_selections{number}', {number: ruleValue}));
}
